import { FunctionComponent as F } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import { SortDirection } from "../../core/types/component";
import HeadingSort from "../UI/Table/HeadingSort";



interface IProps
{
  key: number;

  headings: { Header: string; accessor: string; }[];

  mentionsSort: SortDirection | null,
  titleSort: SortDirection | null,
  platformSort: SortDirection | null,
  dateSort: SortDirection | null,
  votesSort: SortDirection | null,
  handleToggleMentionsSort: () => void,
  handleToggleTitleSort: () => void,
  handleTogglePlatformSort: () => void,
  handleToggleDateSort: () => void,
  handleToggleVotesSort: () => void
}


const RefsTableHeader: F<IProps> = (props: IProps) =>
{
  return (
    <TableHead>
      <TableRow>
        {props.headings.map((heading, i) =>
          <TableCell key={i}>
            {(() =>
            {
              const accessor = heading.accessor;
              const header = heading.Header;

              switch(accessor)
              {
              case 'location':
              case 'url':
              case 'startTime':
                return (<b>{header}</b>);
              case 'title':
                return(
                  <HeadingSort
                    headingText={props.headings[0].Header}
                    sort={props.titleSort}
                    handleToggleSort={props.handleToggleTitleSort} />);
              case 'platform':
                return(
                  <HeadingSort
                    headingText={props.headings[1].Header}
                    sort={props.platformSort}
                    handleToggleSort={props.handleTogglePlatformSort} />);
              case 'date':
                return(
                  <HeadingSort
                    headingText={props.headings[2].Header}
                    sort={props.dateSort}
                    handleToggleSort={props.handleToggleDateSort} />);
              case 'nRefsInPost':
                return(
                  <HeadingSort
                    headingText={props.headings[4].Header}
                    sort={props.mentionsSort}
                    handleToggleSort={props.handleToggleMentionsSort} />);
              case 'votes':
                return(
                  <HeadingSort
                    headingText={props.headings[5].Header}
                    sort={props.votesSort}
                    handleToggleSort={props.handleToggleVotesSort} />);
              }
            })()}
          </TableCell>)}
        <TableCell/>
      </TableRow>
    </TableHead>);
};


export default RefsTableHeader;
